module.exports = __webpack_public_path__ + "img/21컷_수정.a6cf97b5.jpg";